import controller from './header.controller';

const template = require('./header.html');

export default {
    bindings: {
        onShowMobileNav: '&',
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/common/header/header.component.js